import React from "react";
import type { RecommendedAreaProps } from "../types";
import { HotCrypto } from "./HotCrypto";
import { HotStock } from "./HotStock";

export const RecommendedArea: React.FC<RecommendedAreaProps> = ({
  onClose,
  activeTab,
  // onTabChange,
  type,
}) => {
  return (
    <div className="flex flex-col">
      <div className="md:p-6 p-4">
        {activeTab === "crypto" && <HotCrypto onClose={onClose} type={type} />}
        {activeTab === "stock" && <HotStock onClose={onClose} type={type} />}
      </div>
    </div>
  );
};
